import { gql } from "@apollo/client";

export const GET_WHOLE_CASK_ISSUES = gql`
  query wholeCaskIssues($where: JSON, $sort: JSON, $limit: Int, $skip: Int) {
    wholeCaskIssues(where: $where, sort: $sort, limit: $limit, skip: $skip) {
      _id
      name
      cover
      nonce
      creator
      status
      updatedAt
      createdAt
    }
  }
`;

export const COUNT_WHOLE_CASK_ISSUES = gql`
  query countWholeCaskIssues($where: JSON) {
    countWholeCaskIssues(where: $where) {
      count
    }
  }
`;
